module.exports = __webpack_public_path__ + "static/media/logo-999.18a2b381.png";